<template>
  <transition-group class="se-hero" name="blur" tag="div">
    <div class="placeholder blur-transition" v-show="currentSrc === null" key="placeholder"></div>
    <canvas class="blur-transition" v-show="currentSrc === loResSrc" height="17" width="27" key="canvas"></canvas>
    <div class="se-hero__bg blur-transition" v-show="currentSrc === hiResSrc" v-bind:style="{ 'background-image': 'url(' + hiResSrc + ')' }" key="image"></div>
    <div class="se-hero__overlay" key="overlay">
      <div class="se-hero__text" key="text">
        <div class="se-hero__text-container l-content">
          <div class="row center-xs">
            <div class="col-xs-14">
              <div class="se-hero__content">
                <h1>
                  <span class="se-hero__top-title t-chartbody">
                    <span class="se-hero__chapter">{{chapter}}</span>
                    <span class="se-hero__section" v-html="section"></span>
                  </span>
                  <span class="se-hero__title" v-html="title"></span>
                </h1>
                <a class="se-hero__scroll" :class="{ 'se-hero__scroll--gray': grayBG }" @click="scrollDown"></a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </transition-group>
</template>

<script>
export default {
  name: 'Hero',
  props: [
    'hiResSrc',
    'loResSrc',
    'chapter',
    'section',
    'title',
    'grayBG'
  ],
  data () {
    return {
      currentSrc: null
    }
  },
  mounted () {
    var loResImg,
      hiResImg,
      that,
      context
    loResImg = new Image()
    hiResImg = new Image()
    that = this
    context = this.$el.getElementsByTagName('canvas')[0].getContext('2d')

    loResImg.onload = function () {
      context.drawImage(loResImg, 0, 0)
      if (that.currentSrc === null) {
        that.currentSrc = that.loResSrc
      }
    }
    hiResImg.onload = function () {
      that.currentSrc = that.hiResSrc
      // console.log('hires')
    }
    loResImg.src = that.loResSrc
    hiResImg.src = that.hiResSrc
  },
  methods: {
    scrollDown () {
      const targetEl = this.$el.nextElementSibling
      if (targetEl) {
        this.$scrollTo(targetEl, 1000)
      }
    }
  }
}
</script>

<style scoped lang="scss">
@import '~@/scss/vars';
  canvas, .placeholder {
    height: calc(100vh - 80px);
    width: 100%;
    position: absolute;
  }
  .placeholder {
    background-color: #333;
  }
  canvas {
  filter: blur(6px);
  }
  .blur-transition {
    transition: opacity linear .4s 0s;
    opacity: 1;
  }
  .blur-enter, .blur-leave {
    opacity: 0;
  }

  h1 {
    color: $white;
    margin: 0;
    font-weight: 500;
  }

  .se-hero {
    position: relative;
    height: calc(100vh - 80px);
    min-height: 320px;
    width: 100%;
    background-color: #333333;
    &:after {
      display: block;
      content: ' ';
      position: absolute;
      top: 0;
      left: 0;
      height: 50%;
      width: 100%;
      background: linear-gradient(to bottom, rgba(0,0,0,0.6) 0%, rgba(0,0,0,0) 100%);
    }
    &__bg {
      height: 100%;
      width: 100%;
      background-size: cover;
      background-position: center;
    }
    &__overlay {
      // background: linear-gradient(to top, rgba(51,51,51,1) 0%, rgba(51,51,51,0) 100%);
      position: absolute;
      bottom: 0;
      left: 0;
      width: 100%;
      height: 50%;
      background: linear-gradient(to top, rgba(0,0,0,0.6) 0%, rgba(0,0,0,0) 100%);
    }
    &__text {
      display: flex;
      height: 100%;
      width: 100%;
      align-items: flex-end;
      padding-bottom: 60px;
      @media (min-width: 768px) {
        padding-bottom: 80px;
      }
    }
    &__text-container {
      width: 100%;
    }
    &__content {
      width: 100%;
      position: relative;
      text-align: left;
    }
    &__top-title {
      display: block;
      margin-bottom: 27px;
      @media (min-width: 768px) {
        margin-bottom: 36px;
      }
    }
    &__section {
      margin-left: 20px;
      @media (min-width: 768px) {
        margin-left: 25px;
      }
    }
    &__title {
      display: block;
      font-size: 42px;
      font-family: $font-primary;
      line-height: 48px;
      @media (min-width: 768px) {
        font-size: 72px;
        line-height: 80px;
      }
    }
    &__scroll {
      border-radius: 4px;
      background-color: #626469;
      // box-shadow: 0px 18px 24px 0px rgba(0, 0, 0, .04);
      width: 40px;
      height: 80px;
      display: block;
      position: absolute;
      bottom: -100px;
      right: 0;
      background-image: url('../assets/Arrow.png');
      background-repeat: no-repeat;
      background-position: center center;
      cursor: pointer;
      @media (min-width: 768px) {
        bottom: -116px;
      }
      &--gray {
        background-color: #626469;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Hero.vue